(function(){
  'use strict';

  /* 🔴 客服 API 基址：固定域名 support.guitu2026.cc（CF 橙云 → 回源 62.234.68.180）。
     ⚠️ 不要写 erp.beibelle74.com（大陆未备案，境外连不上），也不要写裸 IP（证书不匹配）。
     ⚠️ 这里只发 API（JSON，KB 级），不再拉 HTML —— 界面已内联在本 section 里。 */
  var API = 'https://support.guitu2026.cc/chat/api/';
  var SITE = 'https://support.guitu2026.cc';

  var LS_TOKEN = 'bb_support_token';
  var LS_CACHE = 'bb_support_cache';
  var LS_WELCOME = 'bb_support_welcome';

  /* 欢迎语前端写死一份：打开瞬间就有内容，不等网络。
     与服务端 WELCOME_TEXT 保持一致（服务端才是权威，start() 返回后覆盖）。
     2026-10-28 末句：把客户身份「请」出来（没邮箱/单号，客服查不到订单档案）。
     2026-10-28 二修：品牌名统一成店名「Beibelle's Gallery」（原来写 BayBayBelle，与整站不一致）。 */
  var WELCOME = 'Hi! Welcome to beibelle74.\n\nAsk us anything — card availability, order status, or shipping. A real person replies here.\n\nAlready ordered? Share your order number or email and we\'ll check it right away.';

  var wrap     = document.getElementById('bbSupportWrap');
  var btn      = document.getElementById('bbSupportBtn');
  var panel    = document.getElementById('bbSupportPanel');
  var closeBtn = document.getElementById('bbSupportClose');
  var fallback = document.getElementById('bbSupportFallback');
  var badge    = document.getElementById('bbSupportBadge');
  var chat     = document.getElementById('bbChat');
  var msgsEl   = document.getElementById('bbMsgs');
  var inp      = document.getElementById('bbInp');
  var sendBtn  = document.getElementById('bbSend');
  var subEl    = document.getElementById('bbSub');
  if(!wrap || !btn || !panel || !msgsEl) return;

  var open = false;
  var token = '';
  var lastId = 0;
  var sending = false;
  var pendingQ = [];      /* token 未就绪时的待发队列（原来是单值 ⇒ 连发两句只剩后一句） */
  var started = false;     // 服务端是否已确认会话（**不能**用"本地有 token"冒充）
  var hadToken = false;    // 本地是否有旧 token（决定要不要给 9 秒兜底）
  var failCount = 0;       // 连续失败次数
  var pollTimer = null;
  var bootTimer = null;
  var pageUrl = location.href;

  /* 🔴 IDENT-20261031：邮件里的客服链接带 `pm=<签名令牌>`。
     邮件是我们发的 ⇒ 收件人地址本来就知道，没必要让客户在客服窗里再手打一遍。
     令牌带签名，站内验签才认；伪造/过期一律当没带，退回「请填邮箱」。 */
  var pmTok = '';
  var pmKicked = false;
  try{
    var _pm = /[?&]pm=([A-Za-z0-9_.\-]{20,400})/.exec(location.search || '');
    if(_pm) pmTok = _pm[1];
  }catch(e){}

  /* ---------------- 买家档案采集（2026-10-28） ----------------
     🔴 只采「客服回消息时真的用得上」的信息，不碰任何隐私敏感项：
        · 屏幕尺寸 / 语言 / 时区 → 判断机型与回复时段（美国客户夜里发消息要留到第二天）
        · document.referrer + 当前 URL 的 UTM/op 参数 → 归因「这个客户从哪来」
        · window.BB_CUST（由 section 在服务端渲出，只有**已登录**客户才有）→ 客户身份
     🔴 采集失败一律静默：客服功能绝不能因为拿不到 screen.width 就挂掉。 */
  function collectEnv(){
    var e = { page: pageUrl, name: '', email: '' };
    try{
      if(window.screen) e.screen = screen.width + 'x' + screen.height + '@' + (window.devicePixelRatio || 1);
    }catch(x){}
    try{ e.lang = navigator.language || ''; }catch(x){}
    try{ e.tz = Intl.DateTimeFormat().resolvedOptions().timeZone || ''; }catch(x){}
    try{ e.ref = document.referrer || ''; }catch(x){}
    /* 🔴 PROMOTER-CHAT-20261031：`?want=promoter` 必须传给后端。
       不传 ⇒ 服务端永远不知道客户是为推广员来的，标签不会打、按钮不会推。
       （这是线上真实断点，回归里直接调 API 是测不出来的。） */
    try{
      var _w = /[?&]want=([A-Za-z0-9_-]{1,24})/.exec(location.search || '');
      if(_w) e.want = _w[1];
      /* IDENT-20261031：带上邮件里的签名身份 ⇒ 服务端建会话时就写进 email 列，
         客服一开窗就知道对面是谁，客户也不用打字。 */
      if(pmTok) e.pm = pmTok;
    }catch(x){}
    try{
      if(window.BB_CUST && (window.BB_CUST.email || window.BB_CUST.id)){
        e.customer = window.BB_CUST;
        e.email = window.BB_CUST.email || '';
        e.name = window.BB_CUST.name || '';
      }
      /* 主题下发的登录邮箱是 BB_CUST_EMAIL（BB_CUST 是 null）——没有这行，
         已登录客户在聊天里点申请也永远被判成"没邮箱"。 */
      if(!e.email){
        var _ce = String(window.BB_CUST_EMAIL || '').trim().toLowerCase();
        if(_ce) e.email = _ce;
      }
    }catch(x){}
    return e;
  }

  function collectEnvWithToken(tk){
    var b = collectEnv();
    b.token = tk || '';
    return b;
  }

  /* ---------------- 状态：送达 / 已读 / 在线 / 打字（2026-10-25） ----------------
     desk_read_id = 服务端记录的「客服从哪一条开始已经读过」。
     id <= desk_read_id 的访客消息 ⇒ Read；否则 Sent（已送达服务器，未被读）。
     online 来自服务端：客服工作台 90s 内有心跳才算在线，**过期必须变灰**。 */
  var deskReadId = 0;
  var onlineState = null;      // null = 还没拿到过真实状态（首屏不发请求）
  var statusMap = {};          // msg.id -> 状态元素
  var subHold = 0;             // 临时提示（发送失败等）的保护截止时间
  var TICK1 = '<svg viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M2.2 7.6 5.4 10.8 11.9 3.4" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var TICK2 = '<svg viewBox="0 0 18 14" fill="none" aria-hidden="true"><path d="M1 7.6 4.2 10.8 10.7 3.4" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/><path d="M6.5 7.6 9.7 10.8 16.2 3.4" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  /* ---------------- 本地缓存：让面板"点开就有内容" ---------------- */
  function readCache(){
    try{
      var raw = localStorage.getItem(LS_CACHE);
      if(!raw) return null;
      var d = JSON.parse(raw);
      if(!d || !d.msgs || !d.msgs.length) return null;
      return d;
    }catch(e){ return null; }
  }
  function writeCache(list){
    try{
      /* 只缓存真的有服务端 id 的消息 —— id=0 的是「还没确认/发送中」，缓存了下次会
         画出一条永远停在 Sending 的假气泡。 */
      var ok = (list || []).filter(function(m){ return m && m.id > 0; });
      var tail = ok.slice(-30);
      localStorage.setItem(LS_CACHE, JSON.stringify({ t: Date.now(), msgs: tail }));
    }catch(e){}
  }

  /* ---------------- 渲染 ---------------- */
  function fmt(iso){
    try{
      var d = new Date(iso);
      if(isNaN(d)) return '';
      var h = d.getHours(), m = d.getMinutes();
      var ap = h >= 12 ? 'PM' : 'AM';
      h = h % 12; if(h === 0) h = 12;
      return h + ':' + (m < 10 ? '0' : '') + m + ' ' + ap;
    }catch(e){ return ''; }
  }

  /* 状态行：三态 + 失败。文字 + 勾号（勾用常量 SVG，不含任何用户数据） */
  function makeSt(){
    var s = document.createElement('div');
    s.className = 'bbs-st';
    s.setAttribute('data-s', 'sending');
    return s;
  }
  function paintSt(el, state){
    if(!el) return;
    if(el.getAttribute('data-s') === state) return;
    el.setAttribute('data-s', state);
    while(el.firstChild) el.removeChild(el.firstChild);
    if(state === 'read' || state === 'sent'){
      var ic = document.createElement('span');
      ic.className = 'bbs-st-ic';
      ic.innerHTML = (state === 'read') ? TICK2 : TICK1;
      el.appendChild(ic);
    }
    var txt = state === 'read' ? 'Read'
            : state === 'sent' ? 'Sent'
            : state === 'failed' ? 'Not sent — tap to retry'
            : 'Sending…';
    el.appendChild(document.createTextNode(txt));
    el.setAttribute('title',
      state === 'read' ? 'Our team has read this'
      : state === 'sent' ? 'Delivered — not read yet'
      : state === 'failed' ? 'Message did not reach us'
      : 'Sending…');
  }
  /* 把「客服已读到哪一条」刷到所有气泡上。只往前进，不会把已读退回未读。 */
  function applyRead(){
    Object.keys(statusMap).forEach(function(k){
      var id = Number(k);
      if(!id) return;
      var el = statusMap[k];
      if(el && id <= deskReadId) paintSt(el, 'read');
    });
  }

  (function(){
    var st2 = document.createElement('style');
    st2.textContent = '.bbs-bub .bbs-actbtn{display:block;width:100%;margin-top:9px;padding:11px 14px;' +
      'border:0;border-radius:10px;background:#0b0b0c;color:#fff;font:600 13.5px/1.2 inherit;' +
      'cursor:pointer} .bbs-bub .bbs-actbtn:disabled{opacity:.55;cursor:default}' +
      '.bbs-bub .bbs-actform{display:flex;gap:7px;margin-top:9px}' +
      '.bbs-bub .bbs-actin{flex:1;min-width:0;padding:10px 12px;border:1px solid #d8d8dc;' +
      'border-radius:10px;font:inherit;font-size:13px;color:#111;background:#fff}' +
      '.bbs-bub .bbs-actin.bad{border-color:#c33}' +
      '.bbs-bub .bbs-actform .bbs-actbtn{width:auto;margin-top:0;padding:10px 16px;white-space:nowrap}' +
      '.bbs-bub .bbs-actok{display:block;margin-top:9px;padding:11px 14px;text-align:center;' +
      'border-radius:10px;background:#f2f2f4;color:#6e6e73;font:600 13px/1.2 inherit}';
    document.head.appendChild(st2);
  })();

  var EMAIL_OK = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

  /* Ask for the address in place. Opening another page for one field loses people,
     and we only get here when the conversation carries no address at all. */
  function askEmailInPlace(btn){
    var form = document.createElement('div');
    form.className = 'bbs-actform';
    var inp = document.createElement('input');
    inp.type = 'email';
    inp.inputMode = 'email';
    inp.autocomplete = 'email';
    inp.placeholder = 'your@email.com';
    inp.className = 'bbs-actin';
    var go = document.createElement('button');
    go.type = 'button';
    go.className = 'bbs-actbtn';
    go.textContent = 'Submit';
    form.appendChild(inp);
    form.appendChild(go);
    btn.parentNode.replaceChild(form, btn);
    try { inp.focus(); } catch (e) {}

    function send(){
      var v = (inp.value || '').trim();
      if(!EMAIL_OK.test(v)){ inp.classList.add('bad'); return; }
      inp.classList.remove('bad');
      go.disabled = true;
      go.textContent = 'Working…';
      api('pub/promoter_apply', {method:'POST', body: JSON.stringify({token: token, email: v, pm: pmTok})})
        .then(function(d){
          if(d && d.ok && !d.need_email){
            /* Stay quiet here. The server writes its own confirmation into the
               conversation; a local copy would show the customer two lines saying
               the same thing. The check mark is enough of an ack for the tap. */
            form.innerHTML = '<span class="bbs-actok">Requested</span>';
            return;
          }
          go.disabled = false;
          go.textContent = 'Try again';
        })
        .catch(function(){
          go.disabled = false;
          go.textContent = 'Try again';
        });
    }
    go.addEventListener('click', send);
    inp.addEventListener('keydown', function(e){
      if(e.key === 'Enter'){ e.preventDefault(); send(); }
    });
  }

  function makeActBtn(name){
    /* 🔴 REWARDS-BTN-20261031：已开通的人不再往聊天里贴链接/二维码 ——
       给一个「返利赠卡中心」按钮，进那页自己复制。用 <a> 而不是 button：
       新标签打开、可长按复制链接、微信/QQ 内置浏览器也能正常跳。 */
    if(name === 'rewards'){
      var a = document.createElement('a');
      a.className = 'bbs-actbtn';
      a.href = 'https://beibelle74.com/pages/rewards';
      a.target = '_blank';
      a.rel = 'noopener';
      a.textContent = 'Open my rewards center';
      a.style.display = 'block';
      a.style.textAlign = 'center';
      a.style.textDecoration = 'none';
      a.style.boxSizing = 'border-box';
      return a;
    }
    var b2 = document.createElement('button');
    b2.type = 'button';
    b2.className = 'bbs-actbtn';
    b2.textContent = (name === 'apply_promoter') ? 'Apply for a promoter account' : 'Continue';
    b2.addEventListener('click', function(){
      if(b2.disabled) return;
      b2.disabled = true;
      b2.textContent = 'Working…';
      api('pub/promoter_apply', {method:'POST', body: JSON.stringify({token: token, pm: pmTok})})
        .then(function(d){
          if(d && d.need_email){ askEmailInPlace(b2); return; }
          b2.textContent = 'Requested';
        })
        .catch(function(){
          b2.disabled = false;
          b2.textContent = 'Apply for a promoter account';
          addMsg({role:'system', at:new Date().toISOString(),
                  body:'Connection hiccup — tap Apply again, or reply here and we will set it up for you.'}, true);
        });
    });
    return b2;
  }

  function addMsg(m, scroll){
    if(!m || typeof m.body !== 'string') return null;
    var isImg = m.body.indexOf('[[img]]') === 0;
    /* 商品卡（2026-10-30）：客服点「发给买家」发来的 [[prod]]{json}。
       🔴 只渲染自家域名下的链接；标题/价格一律 textContent，防注入。 */
    var isProd = m.body.indexOf('[[prod]]') === 0;
    var row = document.createElement('div');
    row.className = 'bbs-row ' + (m.role === 'visitor' ? 'me' : (m.role === 'system' ? 'sys' : 'them'));
    var bub = document.createElement('div');
    bub.className = 'bbs-bub' + (isImg ? ' pic' : '');
    if(isProd){
      var pd = null;
      try{ pd = JSON.parse(m.body.slice(8)); }catch(e){ pd = null; }
      bub.className = 'bbs-bub pcard';
      if(pd && pd.t){
        var pw = document.createElement('div');
        pw.className = 'pc-w';
        var pi = null;
        if(pd.i){
          pi = document.createElement('img');
          pi.alt = ''; pi.loading = 'lazy'; pi.src = pd.i;
          pw.appendChild(pi);
        }
        var pn = document.createElement('div');
        pn.className = 'pc-n';
        var pt = document.createElement('b');
        pt.textContent = pd.t;
        pn.appendChild(pt);
        var ps = document.createElement('i');
        ps.textContent = [pd.p, pd.s].filter(Boolean).join(' · ');
        pn.appendChild(ps);
        pw.appendChild(pn);
        bub.appendChild(pw);
        var ok = pd.u && /^https?:\/\/([a-z0-9.-]*\.)?beibelle74\.com\//i.test(pd.u);
        if(ok){
          var pa = document.createElement('a');
          pa.className = 'pc-go';
          pa.href = pd.u;
          pa.target = '_blank';
          pa.rel = 'noopener';
          pa.textContent = '查看这张卡 →';
          bub.appendChild(pa);
        }
      }else{
        bub.textContent = '[商品]';
      }
    }else if(isImg){
      var im = document.createElement('img');
      im.alt = 'Photo';
      im.loading = 'lazy';
      im.src = SITE + m.body.slice(7);
      im.addEventListener('click', function(){ window.open(im.src, '_blank', 'noopener'); });
      bub.appendChild(im);
    }else if(m.body.indexOf('[[act:') === 0){
      /* 动作消息：渲染成**可点按钮**。用 visit token 直接申请，客户不用跳页。 */
      var _e2 = m.body.indexOf(']]');
      var _act = m.body.slice(6, _e2);
      bub.textContent = m.body.slice(_e2 + 2).replace(/^\s+/, '');
      bub.appendChild(makeActBtn(_act));
    }else{
      setRichText(bub, m.body);
    }
    var st = null;
    if(m.role === 'system'){
      row.appendChild(bub);
    }else{
      var t = document.createElement('div');
      t.className = 'bbs-tm';
      t.textContent = isImg ? '' : fmt(m.at);
      if(m.role === 'visitor'){
        /* 买家自己的消息：时间在左，气泡 + 状态行在右（纵向一列） */
        var stack = document.createElement('div');
        stack.className = 'bbs-stack';
        stack.appendChild(bub);
        st = makeSt();
        if(m.id){
          statusMap[m.id] = st;
          paintSt(st, (m.id <= deskReadId) ? 'read' : 'sent');
        }else{
          paintSt(st, 'sending');
        }
        stack.appendChild(st);
        row.appendChild(t); row.appendChild(stack);
      }else{
        row.appendChild(bub); row.appendChild(t);
      }
    }
    msgsEl.appendChild(row);
    if(scroll) msgsEl.scrollTop = msgsEl.scrollHeight;
    return st;
  }

  function clearMsgs(){ msgsEl.innerHTML = ''; statusMap = {}; }

  function renderList(list, scroll){
    clearMsgs();
    lastId = 0;
    (list || []).forEach(function(m){
      addMsg(m, false);
      if(m.id > lastId) lastId = m.id;
    });
    applyRead();
    if(scroll) msgsEl.scrollTop = msgsEl.scrollHeight;
  }

  /* ---------------- 在线状态 / 打字 / 副标题 ---------------- */
  function subDefault(){
    return onlineState === true
      ? 'Online now · Typically replies in a minute'
      : 'Typically replies within a few hours';
  }
  /* holdMs > 0 ⇒ 临时提示（发送失败、正在连接），在保护期内不被状态刷新覆盖 */
  function setSub(text, holdMs){
    if(!subEl) return;
    if(holdMs){ subHold = Date.now() + holdMs; subEl.textContent = text; return; }
    if(Date.now() < subHold) return;
    subEl.textContent = text;
  }
  function setOnline(on){
    on = (on === true);
    if(onlineState === on) return;
    onlineState = on;
    if(wrap) wrap.setAttribute('data-online', on ? '1' : '0');
    if(chat) chat.setAttribute('data-online', on ? '1' : '0');
    setSub(subDefault());
  }
  function setTyping(on){
    if(chat) chat.setAttribute('data-typing', on ? '1' : '0');
  }
  /* start / poll 共用的状态块 —— 🔴 没有新消息时也必须刷（「你那条被读了」就发生在这一拍） */
  function applyState(d){
    if(!d) return;
    var rid = Number(d.desk_read_id);
    if(!isNaN(rid) && rid > deskReadId){ deskReadId = rid; applyRead(); }
    setOnline(d.online === true);
    setTyping(d.typing === true);
  }

  /* ---------------- 网络 ---------------- */
  function api(path, opts){
    var h = {'Content-Type':'application/json'};
    if(token) h['X-Visitor-Token'] = token;
    return fetch(API + path, Object.assign({ headers: h, credentials:'omit', mode:'cors' }, opts || {}))
      .then(function(r){
        if(!r.ok) throw new Error('http ' + r.status);
        return r.json();
      })
      .then(function(d){
        chat.setAttribute('data-offline','0');
        failCount = 0;
        return d;
      })
      .catch(function(e){
        chat.setAttribute('data-offline','1');
        failCount++;
        if(failCount >= 3 && !started) showFallback(true);
        throw e;
      });
  }

  /* 🔴 单飞：setOpen 和 send 都可能调 start，若各发一次就会**建出两个会话**
     （实测：token 被第二次覆盖 ⇒ 消息写进 A 会话、界面在查 B 会话 ⇒ 永远看不到自己发的话）。 */
  var startP = null;
  function start(){
    if(startP) return startP;
    startP = startOnce().then(function(r){ startP = null; return r; },
                             function(e){ startP = null; throw e; });
    return startP;
  }
  function startOnce(){
    var saved = '';
    try{ saved = localStorage.getItem(LS_TOKEN) || ''; }catch(e){}
    return api('pub/start', {
      method:'POST',
      body: JSON.stringify(collectEnvWithToken(saved))
    }).then(function(d){
      if(!d || !d.ok) return;
      started = true;
      showFallback(false);
      clearTimeout(bootTimer);
      token = d.token;
      try{ localStorage.setItem(LS_TOKEN, token); }catch(e){}
      var list = d.messages || [];
      /* 只在"确实有新内容"时重绘，避免把用户正在看的位置刷掉 */
      var newLast = 0;
      list.forEach(function(m){ if(m.id > newLast) newLast = m.id; });
      if(newLast !== lastId || !msgsEl.children.length){
        var atBottom = (msgsEl.scrollHeight - msgsEl.scrollTop - msgsEl.clientHeight) < 60;
        renderList(list, !atBottom);
      }
      writeCache(list);
      cacheWelcome(list);     /* 记住服务端当前欢迎语，下次首屏直接用它（后台可自定义） */
      applyState(d);          /* 打开瞬间就把「已读游标 / 在线 / 打字」校准到真实值 */
      setSub(subDefault());
      flushPending();
    }).catch(function(){});
  }

  function poll(){
    if(!token || !started) return;
    api('pub/poll?after=' + lastId)
      .then(function(d){
        if(!d || !d.ok) return;
        /* 🔴 状态先刷、消息后刷：没有新消息的这一拍，恰恰是「客服刚读了你那条」
           或者「客服正在打字」的时刻，早退会把这些全漏掉。 */
        applyState(d);
        var list = d.messages || [];
        if(!list.length) return;
        var incoming = 0;
        var fresh = [];
        /* 🔴 必须先判 id > lastId 再上屏 —— 否则 send() 后紧跟的这次 poll
           会把「刚发出去那条 + 欢迎语」再画一遍，出现重复气泡。 */
        list.forEach(function(m){
          if(!(m.id > lastId)) return;
          if(m.role === 'desk') incoming++;
          addMsg(m, open);
          lastId = m.id;
          fresh.push(m);
        });
        if(!fresh.length) return;
        if(!open && incoming) setBadge(incoming);
        /* 增量合并进缓存 */
        var c = readCache();
        var all = (c && c.msgs ? c.msgs : []).concat(fresh);
        writeCache(all);
      })
      .catch(function(){});
  }

  function send(){
    var body = (inp.value || '').trim();
    if(!body || sending) return;

    /* 🔴 token 还没就绪（首次打开、跨洋 start 仍在路上）时**绝不能静默丢消息**：
       原来这里直接 return，用户点了发送什么都没发生 —— 这是最伤人的一种 bug。
       现在改成排队：先把内容收走、锁住输入框，start 一成功立刻补发。 */
    if(!token){
      pendingQ.push(body);
      inp.value = '';
      inp.style.height = 'auto';
      sendBtn.disabled = true;
      setSub('Connecting… your message will be sent', 8000);
      if(!started){
        start().then(function(){
          if(token){ markRead(); reportPage(); loop(); flushPending(); }
        });
      }
      return;
    }
    sendBody(body);
  }

  function flushPending(){
    if(!pendingQ.length || !token) return;
    var q = pendingQ.slice();
    pendingQ = [];
    q.forEach(function(b){ sendBody(b); });
  }

  function sendBody(body){
    if(!body || sending || !token) return;
    sending = true;
    sendBtn.disabled = true;
    /* 🔴 先上屏（Sending…），不等跨洋往返 —— 买家点了发送必须立刻看见自己那句话。
       成功 ⇒ 同一行变 Sent（服务器已收）；失败 ⇒ 变 Not sent，并把原文放回输入框。 */
    inp.value = '';
    inp.style.height = 'auto';
    var stEl = addMsg({ id:0, role:'visitor', body:body, at:new Date().toISOString() }, true);
    setSub('Sending…', 0);
    api('pub/send', { method:'POST', body: JSON.stringify({ token: token, body: body }) })
      .then(function(d){
        if(d && d.ok){
          sendBtn.disabled = true;
          /* lastId 必须直接对齐到服务端返回的 id（不是 id-1），否则下一次 poll 会把
             这条又拉回来、再画一遍 ⇒ 重复气泡（实测踩过）。 */
          if(d.id){
            lastId = d.id;
            statusMap[d.id] = stEl;
            paintSt(stEl, (d.id <= deskReadId) ? 'read' : 'sent');
            var c0 = readCache();
            writeCache((c0 && c0.msgs ? c0.msgs : []).concat([
              { id: d.id, role:'visitor', body: body, at: new Date().toISOString() }
            ]));
          }else{
            paintSt(stEl, 'sent');
          }
          setSub(subDefault());
          poll();
        }else{
          paintSt(stEl, 'failed');
          sendBtn.disabled = false;
          chat.setAttribute('data-offline','1');
          setSub('Send failed — tap send to retry', 6000);
        }
      })
      .catch(function(){
        paintSt(stEl, 'failed');
        sendBtn.disabled = false;
        chat.setAttribute('data-offline','1');
        /* 发失败别把用户写的东西弄丢：放回输入框 */
        if(!inp.value) inp.value = body;
        setSub('Send failed — tap send again', 6000);
      })
      .then(function(){ sending = false; });
  }

  function markRead(){
    if(!token) return;
    api('pub/read', { method:'POST', body: JSON.stringify({ token: token }) }).catch(function(){});
  }

  function reportPage(){
    if(!token) return;
    api('pub/page', { method:'POST', body: JSON.stringify({ token: token, page: pageUrl }) }).catch(function(){});
  }

  /* ---------------- 购物车快照（2026-10-30） ----------------
     🔴 客服最想知道「买家车里放了什么」—— 只看当前页远远不够。
        这里读 Shopify 原生 /cart.js（同源、只读、不需要任何权限），
        只提炼客服真用得上的四样：商品名 / 数量 / 单价 / handle。
     🔴 拿不到就静默：cart.js 可能被主题改动、可能 404 —— 绝不影响聊天。 */
  var cartSentAt = 0;
  /* cart.js 的 title 是已经 HTML 转义过的（Red&#39;s）⇒ 先解码再上报，
     否则工作台会原样显示 &#39;（实测踩过）。 */
  function unent(s){
    try{
      var d = document.createElement('textarea');
      d.innerHTML = String(s == null ? '' : s);
      return d.value;
    }catch(e){ return String(s == null ? '' : s); }
  }
  function reportCart(){
    if(!token) return;
    if(Date.now() - cartSentAt < 20000) return;   /* 20 秒内不重复打 */
    if(typeof fetch !== 'function') return;
    fetch('/cart.js', { credentials:'same-origin' })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(c){
        if(!c || !c.items || !c.items.length) return;
        var items = c.items.slice(0, 20).map(function(it){
          return {
            t: unent(it.title).slice(0, 80),
            q: Number(it.quantity || 0),
            p: (Number(it.price || 0) / 100),
            h: String(it.handle || (it.url || '').split('/products/')[1] || '').split('?')[0].slice(0, 80),
            i: String(it.image || '').slice(0, 300),
            /* NOPAY-20261031：变体 ID —— 客服「发结账链接」靠它生成购物车直推，
               没有它就只能在客户没走进结账页时发商品页（多一步加购，转化差很多） */
            v: Number(it.variant_id || 0)
          };
        });
        cartSentAt = Date.now();
        api('pub/cart', { method:'POST', body: JSON.stringify({ token: token, items: items }) })
          .catch(function(){});
      })
      .catch(function(){});
  }

  /* ---------------- 轮询节奏 ----------------
     打开：3s（对话流畅）
     关闭：60s（只为拿未读角标，少跨洋）
     页面不可见：停（省流量，也省对方服务器） */
  function stopPoll(){ if(pollTimer){ clearInterval(pollTimer); pollTimer = null; } }
  function loop(){
    stopPoll();
    pollTimer = setInterval(function(){
      if(document.hidden) return;
      poll();
    }, open ? 3000 : 60000);
  }

  /* ---------------- 面板开关 ---------------- */
  function showFallback(on){
    if(fallback) fallback.hidden = !on;
    if(chat) chat.style.visibility = on ? 'hidden' : 'visible';
  }

  /* 🔴 REGRESS-20261030：原来传进来的是「这一拍新增几条」，买家连发 3 条时角标可能只显示 1。
     改成累计（面板打开即清零），封顶 9+。 */
  var badgeN = 0;
  function setBadge(n){
    if(!badge) return;
    if(open || n <= 0){ badgeN = 0; badge.hidden = true; return; }
    badgeN += n;
    badge.textContent = badgeN > 9 ? '9+' : String(badgeN);
    badge.hidden = false;
  }

  function paintFromCache(){
    var c = readCache();
    if(c && c.msgs && c.msgs.length){
      renderList(c.msgs, true);
      return true;
    }
    /* 没缓存 ⇒ 至少把欢迎语画出来，绝不给空白 */
    renderList([{ role:'desk', body: welcomeNow(), at: new Date().toISOString() }], true);
    return false;
  }

  /* 欢迎语已可由客服在后台自定义（2026-10-28）。
     🔴 首屏那一瞬没有网络，只能用「上次服务端给的文案」（localStorage）+ 兜底常量。
        这样客服改过文案后，老访客第二次进来首屏就是新文案，不会先闪一句旧的再被覆盖。 */
  function welcomeNow(){
    try{
      var v = localStorage.getItem(LS_WELCOME);
      if(v) return v;
    }catch(e){}
    return WELCOME;
  }
  function cacheWelcome(list){
    try{
      for(var i = 0; i < (list || []).length; i++){
        var m = list[i];
        if(m && m.role === 'desk' && m.body && m.body.length > 8){
          localStorage.setItem(LS_WELCOME, m.body);
          return;
        }
      }
    }catch(e){}
  }

  function setRichText(el,text){
  function esc(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];}
  function escAll(t){return String(t).replace(/[&<>"']/g,esc).replace(/\n/g,'<br>');}
  var s0=String(text==null?'':text), re=/(https?:\/\/[^\s<>"']+)/g, out='', last=0, m;
  while((m=re.exec(s0))){
    out+=escAll(s0.slice(last,m.index));
    var u=m[1], su=u.replace(/"/g,'&quot;');
    if(/referral-hook\/qr|\/qr\?|\.(png|jpe?g|webp|gif)(\?|$)/i.test(u)){
      out+='<img src="'+su+'" alt="QR code" loading="lazy" style="display:block;width:168px;height:168px;margin:8px 0;border-radius:10px;background:#fff;border:1px solid #eee">';
    }else{
      out+='<a href="'+su+'" target="_blank" rel="noopener" style="color:inherit;text-decoration:underline;word-break:break-all">'+escAll(u)+'</a>';
    }
    last=m.index+u.length;
  }
  out+=escAll(s0.slice(last));
  el.innerHTML=out;
}
function setOpen(v){
    open = !!v;
    wrap.setAttribute('data-open', open ? 'true' : 'false');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if(open){
      /* 秒开：先画本地内容，再打网络 */
      paintFromCache();
      panel.hidden = false;
      setBadge(0);
      /* 🔴 每次打开都确保拿到会话：本地有 token 不代表服务端还认它
         （换库 / 清数据 / token 过期），start() 会带着旧 token 去换回同一条会话。 */
      if(!started){
        clearTimeout(bootTimer);
        if(!hadToken){
          /* 新访客：9 秒还没连上就兜底给邮箱，绝不让买家对着空框等 */
          bootTimer = setTimeout(function(){ if(!started) showFallback(true); }, 9000);
        }
        start().then(function(){
          if(token){ markRead(); reportPage(); reportCart(); loop(); }
        });
      }else{
        if(token) markRead();
        poll();
        reportPage();
        reportCart();
      }
      /* 桌面才自动聚焦，手机不聚焦（否则一开窗就弹键盘挡住消息） */
      if(window.innerWidth > 480){
        setTimeout(function(){ try{ inp.focus({preventScroll:true}); }catch(e){} }, 240);
      }
      loop();
    }else{
      panel.hidden = true;
      loop();
    }
  }

  /* ---------------- 事件 ---------------- */
  btn.addEventListener('click', function(){ setOpen(true); });
  if(closeBtn) closeBtn.addEventListener('click', function(e){ e.preventDefault(); setOpen(false); });
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape' && open) setOpen(false);
  });

  sendBtn.addEventListener('click', send);

  /* ---------------- 图片附件（2026-10-23 新增） ----------------
     选图 / 粘贴截图 / 拖入 → 前端压到最长边 1600 JPEG → raw binary 直传 */
  var attachBtn = document.getElementById('bbAttach');
  var fileInput = document.getElementById('bbFile');

  /* 压缩后仍可能超后端 3MB（超大 GIF）⇒ 统一在这里兜住，给一句人话提示 */
  var MAX_OUT = 3 * 1024 * 1024;

  function compressImg(file){
    return new Promise(function(resolve, reject){
      /* GIF 动图 canvas 压不了（会丢帧），但也不能原图硬塞 —— 超过 3MB 直接拒，别让他一直重试 */
      if(file.type === 'image/gif'){
        if(file.size > MAX_OUT){ reject(new Error('gif too large')); return; }
        resolve(file); return;
      }
      var url = URL.createObjectURL(file);
      var im = new Image();
      im.onload = function(){
        try{
          var w = im.naturalWidth, h = im.naturalHeight;
          var k = Math.min(1, 1600 / Math.max(w, h));
          w = Math.round(w * k); h = Math.round(h * k);
          var cv = document.createElement('canvas');
          cv.width = w; cv.height = h;
          var ctx = cv.getContext('2d');
          ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, w, h);
          ctx.drawImage(im, 0, 0, w, h);
          cv.toBlob(function(b){
            URL.revokeObjectURL(url);
            b ? resolve(b) : reject(new Error('compress failed'));
          }, 'image/jpeg', 0.85);
        }catch(e){ URL.revokeObjectURL(url); reject(e); }
      };
      im.onerror = function(){ URL.revokeObjectURL(url); reject(new Error('not an image')); };
      im.src = url;
    });
  }

  var uploadingImg = false;
  function uploadImage(file){
    if(!file || uploadingImg) return;
    if(!/^image\//.test(file.type || '')) return;
    /* 🔴 REGRESS-20261030：后端 MAX_IMG=3MB。原图 12MB 是**给压缩留的余量**（压完通常 200~600KB），
       真正的闸门在压缩后（见 MAX_OUT）与 GIF 分支 —— 原来放行 12MB 却无下游校验，
       3~12MB 的图必然 413，提示却是「try again」，重试永远不成功。 */
    if(file.size > 12 * 1024 * 1024){
      setSub('That photo is too large (max 12MB)', 4000);
      return;
    }
    /* token 未就绪：先 start，成功后补发（与文字消息同一套「绝不静默丢」原则） */
    if(!token){
      if(!started){
        start().then(function(){ if(token) uploadImage(file); });
      }
      return;
    }
    uploadingImg = true;
    if(attachBtn) attachBtn.setAttribute('data-busy', '1');
    compressImg(file)
      .then(function(blob){
        if(blob && blob.size > MAX_OUT) throw new Error('too large after compress');
        return fetch(API + 'pub/upload', {
          method:'POST',
          headers:{'Content-Type': blob.type || 'image/jpeg', 'X-Visitor-Token': token},
          body: blob, credentials:'omit', mode:'cors'
        }).then(function(r){ return r.json(); });
      })
      .then(function(d){
        if(d && d.ok){ poll(); }
        else { setSub('Could not send the photo — try again', 4000); }
      })
      .catch(function(e){
        setSub(String((e && e.message) || '').indexOf('large') >= 0
          ? 'That photo is too large — please send a smaller one'
          : 'Could not send the photo — try again', 4000);
      })
      .then(function(){
        uploadingImg = false;
        if(attachBtn) attachBtn.removeAttribute('data-busy');
      });
  }

  if(attachBtn && fileInput){
    attachBtn.addEventListener('click', function(){ fileInput.click(); });
    fileInput.addEventListener('change', function(){
      var f = this.files && this.files[0];
      if(f) uploadImage(f);
      this.value = '';
    });
  }
  document.addEventListener('paste', function(e){
    var items = (e.clipboardData && e.clipboardData.items) || [];
    for(var i = 0; i < items.length; i++){
      if(items[i].kind === 'file' && /^image\//.test(items[i].type)){
        var f = items[i].getAsFile();
        if(f){ e.preventDefault(); setOpen(true); uploadImage(f); return; }
      }
    }
  });
  var dropDepth = 0;
  document.addEventListener('dragenter', function(e){
    if(e.target && e.target.closest && e.target.closest('#bbSupportWrap')){ dropDepth++; e.preventDefault(); }
  });
  document.addEventListener('dragover', function(e){
    if(e.target && e.target.closest && e.target.closest('#bbSupportWrap')) e.preventDefault();
  });
  document.addEventListener('dragleave', function(){ dropDepth = Math.max(0, dropDepth - 1); });
  document.addEventListener('drop', function(e){
    if(!(e.target && e.target.closest && e.target.closest('#bbSupportWrap'))) return;
    var fs = e.dataTransfer && e.dataTransfer.files;
    if(fs && fs[0]){ e.preventDefault(); dropDepth = 0; setOpen(true); uploadImage(fs[0]); }
  });

  inp.addEventListener('input', function(){
    inp.style.height = 'auto';
    inp.style.height = Math.min(inp.scrollHeight, 96) + 'px';
    sendBtn.disabled = !(inp.value || '').trim();
  });
  inp.addEventListener('keydown', function(e){
    if(e.key === 'Enter' && !e.shiftKey && !e.isComposing){
      e.preventDefault();
      if((inp.value || '').trim()) send();
    }
  });

  /* 底部 Checkout 横条动态避让 */
  function syncLift(){
    var bar = document.querySelector('.cartbar');
    var h = 0;
    /* BALL-LIFT-FIX-20261025：只有「真的显示出来」的结算条才抬球。
       .cartbar 隐藏方式是 opacity:0 + translateY(130%)（brand.css:1618），
       所以旧的 display/visibility/offsetHeight 三判**恒真** ⇒ 空车也白抬 50px，
       球会压在 FAQ 联系卡右下角，页尾还得为它留一大块白。 */
    if(bar && bar.classList.contains('on')){
      if(bar.offsetHeight > 0) h = bar.offsetHeight;
    }
    wrap.style.setProperty('--bbs-lift', h + 'px');
  }
  syncLift();
  window.addEventListener('resize', syncLift);
  window.addEventListener('orientationchange', syncLift);
  var barEl = document.querySelector('.cartbar');
  if(barEl && window.MutationObserver){
    new MutationObserver(syncLift).observe(barEl, { attributes:true, attributeFilter:['class','style'] });
  }

  /* ---------------- 启动 ----------------
     首屏**不建连接、不发请求**：只读 localStorage 里有没有 token。
     真正联网发生在用户第一次点球（或恢复上次打开状态）时。 */
  wrap.setAttribute('data-state','in');
  /* CHAT-FLASH-20261026：首帧锁解除 —— 到这一行说明 CSS 已生效、DOM 已就绪，
     再让它显示。用 rAF 保证「先按 hidden 完成一次布局，再显形」，避免同一帧内切换。 */
  requestAnimationFrame(function(){ wrap.setAttribute('data-ready','1'); });
  /* ---------------- MAIL-REPLY-20261031：邮件深链 ----------------
     ?bbchat=<visitor_token> 是「客服离线回信」邮件里那个按钮带回来的参数。
     场景：买家关掉页面 → 客服回信发到他邮箱 → 他点按钮回来。
     🔴 必须**先把这个 token 写进本地**再 start：否则 start 会新建一个空会话，
        买家看到的是空白聊天框，以为记录丢了（比不回来还糟）。
     🔴 参数用完就从地址栏摘掉（只删 bbchat，保留 ref 等归因参数）。 */
  (function deepLink(){
    var m = /[?&]bbchat=([A-Za-z0-9_\-]{8,64})/.exec(location.search || '');
    if(!m) return;
    var tk = m[1];
    try{ localStorage.setItem(LS_TOKEN, tk); }catch(e){}
    token = tk;
    hadToken = true;
    setTimeout(function(){ setOpen(true); }, 120);
    setTimeout(function(){
      try{
        var u = new URL(location.href);
        u.searchParams.delete('bbchat');
        history.replaceState({}, '', u.pathname + (u.search || '') + (u.hash || ''));
      }catch(e){}
    }, 1500);
  })();
  try{
    hadToken = !!localStorage.getItem(LS_TOKEN);
    if(hadToken) token = localStorage.getItem(LS_TOKEN) || '';
  }catch(e){}
  /* 🔴 NO-RESTORE-20261031：客服窗**不再自动恢复**。
     以前记「上次开着」→ 客户点邮件里的返利中心，面板自己盖上来（手机上它 400px 宽，
     差不多半个屏幕），看着就是"页面被跳到了客服"。侯哥 19:44 真机实测报的就是这条。
     现在只有两种方式会展开：① 客户自己点浮动球；② 链接明确带 want= / bbchat=。
     代价只是"聊完再跳页需要多点一下球"，比不请自来的弹窗小得多。 */
  try{
    /* MAIL-PROMOTER-CHAT-20261031：外链/邮件带 want=<用途> 进来 ⇒ **直接展开客服窗**。
       侯哥要求「点申请推广员直接进客服界面」——只传 want 不展开，客户还得自己找右下角。
       挂 120ms 是因为上面的 setOpen(true) 恢复也在这个时间窗，避免两条路径互相覆盖。 */
    if(/[?&]want=/.test(location.search)){
      setTimeout(function(){ try{ setOpen(true); }catch(e){} }, 120);
    }
  }catch(e){}
})();
